module.exports = __webpack_public_path__ + "img/Wp_2090.4004194b.png";